import { formatUKDate } from 'src/helpers';
import _ from 'lodash';

export type MappingType = { [key: number]: string };
export type DateFormatter = (date: Date) => string;

export const getValueFromMapping = (key: number | null | undefined, valueMapping: MappingType): string => {
    if (_.isNil(key)) {
        return '-';
    }
    return valueMapping.hasOwnProperty(key) ? valueMapping[key] : '-';
};

export const getValueRenderDate = (date: Date | null, formatFunction: DateFormatter) => {
    return date ? formatFunction(date) : 'N/A';
};

export const getValueRenderBoolean = (value: boolean | null, valueTrue?: string, valueFalse?: string) =>
    value !== null ? (value ? valueTrue ?? 'True' : valueFalse ?? 'False') : 'N/A';
